import React from "react";
import { Box, Grid, Paper } from "@material-ui/core";
import { useNavigate } from "react-router-dom";

import DetailsTxt from "./DetailsTxt";
import DetailsImg from "./DetailsImg";
//----------------------------------
// import {
//   Magnifier,
//   GlassMagnifier,
//   SideBySideMagnifier,
//   PictureInPictureMagnifier,
//   MOUSE_ACTIVATION,
//   TOUCH_ACTIVATION,
// } from "react-image-magnifiers";
//----------------------------------

//import useStyles from "../Product/styles";
import { Helmet } from "react-helmet";

function PubProductDetails(props) {
  const product = props.selectedProduct; // Use props directly
  //const [ringSizeRequired, setRingSizeRequired] = useState(false);

  //const classes = useStyles();
  const navigate = useNavigate();

  //var randomColor = require("randomcolor");
  //var CurrencyFormat = require("react-currency-format");

  let imageUrl = process.env.REACT_APP_API_HOST + product.PrimaryImageUrl;
  let imageUrlSc = process.env.REACT_APP_API_HOST + product.SecondaryImageUrl;

  const handleAddToCart = () => {
    props.handleAddToCart(product.ProductId, 1);
    navigate("/cart");
  };

  return (
    <div style={{ marginTop: "60px" }}>
      <Helmet>
        <title>{product.ProductName}</title>
        <meta name="description" content={product.Description} />
      </Helmet>
      <Box sx={{ display: "flex", width: "100%", height: "100%", marginTop: "60px" }}>
        <Grid container spacing={2} margin={2}>
          <Grid item xs={12} sm={6}>
            <Paper elevation={3} style={{ flex: 1, padding: "20px", margin: 1 }}>
              <DetailsImg primaryImageUrl={imageUrl} secondaryImageUrl={imageUrlSc} />
            </Paper>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Paper elevation={3} style={{ flex: 1, padding: "20px", margin: 1 }}>
              <DetailsTxt product={product} ringSizes={props.ringSizes} handleAddToCart={handleAddToCart} />
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default PubProductDetails;
